<template>
  <div class="wrapper">
    <SideBarMenu />
    <div class="content main-content">
      <dashboard-navbar :type="$route.meta.navbarType"></dashboard-navbar>

      <div @click="$sidebar.displaySidebar(false)">
        <base-header class="pb-1 bg-gradient-dark">
          <b-row aling-v="center" class="py-4">
            <b-col cols="7" lg="6">
              <!--   <h6 class="h2 text-white d-inline-block mb-0">
                {{ $route.meta.name ? $route.meta.name : "Default" }}
              </h6> -->
              <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
                <route-bread-crumb></route-bread-crumb>
              </nav>
            </b-col>
            <b-col cols="5" lg="6" class="text-right">
              <base-button
                v-if="this.$store.getters['getAddFunction'] != null"
                size="sm"
                type="success"
                @click="onAddMethod()"
                >New</base-button
              >
            </b-col>
          </b-row>
          <BoardCards />
        </base-header>
        <fade-transition :duration="200" origin="center top" mode="out-in">
          <!-- your content here -->

          <router-view :key="$router.meta"></router-view>
        </fade-transition>
      </div>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-new */
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

import ContentFooter from "./ContentFooter.vue";
import { FadeTransition } from "vue2-transitions";
import DashboardNavbar from "./DashboardNavbar.vue";
import SideBarMenu from "./SideBarMenu.vue";
import BoardCards from "./components/BoardCards.vue";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { mapState } from "vuex";

export default {
  components: {
    ContentFooter,

    FadeTransition,
    DashboardNavbar,
    BoardCards,
    SideBarMenu,
    RouteBreadCrumb,
  },
  computed: {
    ...mapState({
      addFunction: (state) => state.layout.boards.addFunction,
    }),
  },
  methods: {
    initScrollbar() {
      let isWindows = navigator.platform.startsWith("Win");
      if (isWindows) {
        initScrollbar("sidenav");
      }
    },
    onAddMethod() {
      this.$store.getters["getAddFunction"]();
    },
  },
  mounted() {
    this.initScrollbar();
    this.$sidebar.toggleMinimize();
  },
};
</script>
<style lang="scss"></style>
